export default __webpack_public_path__ + "static/media/peer_infrastructure_horizontal.997b3a40.mp4";